import { convertFromRaw, EditorState, RawDraftContentState } from 'draft-js';
import { isObjectLike } from 'lodash';
import { CellData } from '../../../../../../common/table/TableTypes';
import { parseCellContentString } from '../../../../../../common/table/utils/tableCellContentStringUtils';

/**
 * Returns whether a cell has the specified inline style, checking both cell-level
 * style metadata and Draft content when present.
 */
export const doesTableCellDataHaveInlineStyles = (cellData: CellData, inlineStyle: string): boolean => {
    if (cellData.textStyle?.includes(inlineStyle)) return true;
    if (!cellData.value) return false;

    const content = cellData.draftContent || parseCellContentString(cellData.value);
    if (!isObjectLike(content)) return false;

    const editorState = EditorState.createWithContent(convertFromRaw(content as RawDraftContentState));
    return editorState.getCurrentInlineStyle().includes(inlineStyle);
};
